import { EvaluationInterface } from 'app/assessment/evaluation/models';
import { TaskInterface } from 'app/task/models';

export interface EvaluationStateInterface {
  ids?: number[];
  evaluations?: { [id: number ]: EvaluationInterface };
  selectedEvaluation?: number;
  currentEvaluation?: EvaluationInterface;
  currentEvaluationRelatedTask?: TaskInterface;
}

export class EvaluationState implements EvaluationStateInterface {
  public ids?: number[];
  public evaluations?: { [id: number ]: EvaluationInterface };
  public selectedEvaluation?: number | null;
  public currentEvaluation?: EvaluationInterface | {};
  public currentEvaluationRelatedTask?: TaskInterface;

  constructor({
    ids = undefined,
    evaluations = undefined,
    selectedEvaluation = undefined,
    currentEvaluation = undefined,
    currentEvaluationRelatedTask = undefined,
    }: EvaluationStateInterface) {
    this.ids = ids;
    this.evaluations = evaluations;
    this.selectedEvaluation = selectedEvaluation;
    this.currentEvaluation = currentEvaluation;
    this.currentEvaluationRelatedTask = currentEvaluationRelatedTask;
  }
}
